<template>
  <v-btn
    rounded
    :icon="!!icon"
    :color="icon ? '' : 'primary'"
    @click="$emit('click')"
    :disabled="disabled || isFetching"
    v-bind="$attrs"
  >
    <v-icon v-if="icon">{{ icon }}</v-icon>
    <span v-else>{{ label || $t('common.save') }}</span>
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex'
import { isFetching } from '@/store/getters'

export default {
  name: 'SubmitButton',
  props: {
    label: String,
    disabled: Boolean,
    icon: String
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([isFetching])
  }
}
</script>
